import { Canvas, useFrame } from "@react-three/fiber";
import React, { useEffect, useRef, useState, useMemo } from "react";
import styleSheet from "./style.module.scss";
import SyPlanet from "../sy-planet";
import SyStar from "../sy-star";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getOrbitDetails, setHoverPlanet } from "../../../feature/orbit-slice";
import { getPlantLayout } from "../../../utils/solar-system";
import { circleProps, solarProps } from "./sy-solar-interface";
import SyIcon from "../sy-icon";
import SyPopup from "../sy-model";
import LiveDetailsPop from "../../../modules/orbit-module/popups/live-detail-popup";
import { setCookie } from "../../../utils/cookie";
import { getLocalData, setLocalData } from "../../../utils/localstorage";
import {
  setHoverStage1,
  setHoverStage2,
  setHoverStage3,
  setHoverStage4,
  setHoverStage5,
} from "../../../feature/community-slice";
import { getCommunityDetails } from "../../../feature/community-slice/community-slice";
import OrbPlanets from "../orb-planets";

const SySolarSystem = (props: solarProps) => {
  const {
    layout,
    planetOnclick,
    solarOnFocus,
    planetHover,
    mask = false,
  } = props;
  const [planetData, setPlanetData] = useState<any>([]);
  const [showLiveStagePopup, setShowLiveStagePopup] = useState<any>(false);
  const orbitSlice = useSelector(getOrbitDetails);
  const communitySlice = useSelector(getCommunityDetails);
  const [isPlanetHover, setIsPlanetHover] = useState<any>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const data = getPlantLayout(layout);
    console.log(data,'data')
    setPlanetData(data);
  }, [layout]);

  const onclickLiveStage = () => {
    if (orbitSlice.selectOrbit) {
      setShowLiveStagePopup(true);
    }
  };

  const onLiveDetailsPop = () => {
    setShowLiveStagePopup(false);
  };

  const handlePlanetClick = (data: any) => {
    dispatch(setHoverPlanet(null));
    if (planetOnclick) planetOnclick(data);
  };


  const Circle = ({ children, speed, status }: any) => {
    const planetRef = useRef<any>(null);
    const lastUpdate = useRef(0);





    // useEffect(() => {
    //   if (status == 1) {
    //     planetRef.current.rotation.z = communitySlice.hoverStage1;
    //   } else if (status == 2) {
    //     planetRef.current.rotation.z = communitySlice.hoverStage2;
    //   } else if (status == 3) {
    //     planetRef.current.rotation.z = communitySlice.hoverStage3;
    //   } else if (status == 4) {
    //     planetRef.current.rotation.z = communitySlice.hoverStage4;
    //   } else if (status == 5) {
    //     planetRef.current.rotation.z = communitySlice.hoverStage5;
    //   }
    // }, [orbitSlice.hoverPlanet]);

    // useFrame((state) => {

    //   if (planetRef.current && !orbitSlice.hoverPlanet) {
    //     planetRef.current.rotation.z -= speed;

    //     const now = state.clock.elapsedTime;
    //     if (now - lastUpdate.current > 0.02 && orbitSlice.selectOrbit) {
    //       // setLocalData(status, planetRef.current.rotation.z);
    //       if (status == 1) {
    //         dispatch(setHoverStage1(planetRef.current.rotation.z));
    //       } else if (status == 2) {
    //         dispatch(setHoverStage2(planetRef.current.rotation.z));
    //       } else if (status == 3) {
    //         dispatch(setHoverStage3(planetRef.current.rotation.z));
    //       } else if (status == 4) {
    //         dispatch(setHoverStage4(planetRef.current.rotation.z));
    //       } else if (status == 5) {
    //         dispatch(setHoverStage5(planetRef.current.rotation.z));
    //       }

    //       lastUpdate.current = now;
    //     }
    //   }
    // });

    return (
      <mesh position={[0, 0, 0]} ref={planetRef}>
        {children}
      </mesh>
    );
  };

  // const RenderPlanet = React.memo(({ orbit }: any) => {
  //   const planets = useMemo(() => {

  //     console.log("render orbit", orbit);
  
  //     return orbit?.planet?.map((data: any) => (
  //       <SyPlanet
  //         speed={
  //           orbit.stage === 3
  //             ? 0.009
  //             : orbit.stage === 2
  //             ? 0.02
  //             : orbit.stage === 1
  //             ? 0.05
  //             : 0
  //         }
  //         key={data.id}
  //         planetDetails={data}

  //         onPlanetHover={handlePlanetHover}
  //       />
  //     ));
  //   }, [planetData]);
  
  //   return planets;
  // });
  
  
  
  // const renderCirce=()=>{

  //   return planetData?.map((orbit: any, index: number) => (
  //     <Circle
  //       key={`orbit-${index}`}
  //       status={orbit.stage}

  //       speed={
  //         orbit.stage === 3
  //           ? 0.008
  //           : orbit.stage === 2
  //           ? 0.005
  //           : orbit.stage === 1
  //           ? 0.005
  //           : 0
  //       }
  //     >
      
  //      <RenderPlanet orbit={orbit} />
       
  //     </Circle>
  //   ));
    
  // }


  const handlePlanetHover = (value: any, type: any) => {
    if (planetHover) planetHover(value, type);
  };

  const renderedPlanets = useMemo(() => {

    return <OrbPlanets planetData={planetData} onPlanetHover={handlePlanetHover}  onPlanetClick={handlePlanetClick}/>
  }, [planetData]);



  return (
    <>
      {showLiveStagePopup && (
        <SyPopup open={showLiveStagePopup} maxWidth={"md"}>
          <LiveDetailsPop
            liveData={planetData[3].planet}
            onClose={onLiveDetailsPop}
          />
        </SyPopup>
      )}

      <div
        className={`${styleSheet.orbit} ${
          mask ? "opacity-25" : ""
        } position-relative rounded-circle `}
      >
        {planetData[3]?.planet?.length ? (
          <p
            className={` ${
              !orbitSlice.selectOrbit ? "font-10" : ""
            } position-absolute rounded-circle top-50 start-50 translate-middle z-3 pointer mohave`}
            onClick={onclickLiveStage}
          >
            {`+${planetData[3]?.planet?.length}`}
          </p>
        ) : null}
        <Canvas>
          <directionalLight position={[0, 4, 5]} />
          {/* {!navDetails.maps && navDetails.selectOrbit && <SyStar />} */}
          {renderedPlanets}
        </Canvas>

        <div
          className={`h-75 w-75 ${styleSheet.sub_orbit}  position-absolute rounded-circle top-50 start-50 translate-middle z-n1`}
        >
          <div
            className={`h-50 w-50 ${styleSheet.sub_orbit} position-absolute rounded-circle top-50 start-50 translate-middle z-n1`}
          >
            <div
              className={`h-25 w-25 ${styleSheet.sub_orbit} position-absolute rounded-circle top-50 start-50 translate-middle z-n1`}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SySolarSystem;
